import get from "lodash/get";
import {resultParamsActionCreator} from "~/actions/result_param_actions";
import {changeGroupOpen, changeFilterOpen, changeFilterOrder, resetFilters, } from "~/actions/settingsActions";
import {getTableSettingsIdentifier, getInitialValuesByFilterName, getFilters} from "~/stateGetter";
import normalizeFieldValue from "~/data/normalizeFieldValue";

export const MODEL_ACTIONS = {
    CHANGE_GROUP_OPEN: 'change_group_open',

    CHANGE_FIELD_VALUE: 'change_field_value',
    CHANGE_SELECT_QUERY: 'change_select_query',
    UPDATED_SELECTED_ROWS: 'update_selected_rows',
    CHANGE_SELECT_OPTIONS: 'change_select_options',
    CHANGE_ACTIVE_ITEM: 'change_active_item',
    CHANGE_FIELD_GROUP_OPEN: 'change_field_group_open',
    HIDE_MESSAGES: 'hide_messages',
    SET_DEFAULT_ITEM: 'set_default_item',
    SET_NEW_ITEM: 'set_new_item',
};

export function modelActionsCreator(modelId, modelName, dispatch = (a) => a) {
    const hideMessages = () => ({ type: MODEL_ACTIONS.HIDE_MESSAGES, modelId });

    return {
        hideMessages,
        ...resultParamsActionCreator({modelId}, dispatch),

        /**
         * Changes a fields value and changes adapters values accordingly, dispatching a changeFieldValue for every one of them
         *
         * @param fieldName
         * @param inputType
         * @param value
         * @returns {function(*, *)}
         */
        changeFieldValue: (fieldName, inputType, value, fieldProps = {}) => {
            return {
                type: MODEL_ACTIONS.CHANGE_FIELD_VALUE,
                inputType,
                fieldName,
                value,
                modelId,
                ...fieldProps
            };
        },


        changeFieldQuery: (fieldName, inputType, query) => dispatch({
            type: MODEL_ACTIONS.CHANGE_SELECT_QUERY,
            fieldName,
            inputType,
            query,
            modelId
        }),

        updateSelectedRows: ({ rowIds, selectThroughout }) => dispatch({
            type: MODEL_ACTIONS.UPDATED_SELECTED_ROWS,
            ids: rowIds,
            selectThroughout,
            modelId
        }),

        resetItemValue: () => {
            return { type: MODEL_ACTIONS.SET_DEFAULT_ITEM, modelId };
        },

        setNewItem: () => {
            return { type: MODEL_ACTIONS.SET_NEW_ITEM, modelId };
        },

        // filter actions
        changeGroupOpen: (filterGroupName, open) => (dispatch, getState) => {
            let identifier = getTableSettingsIdentifier(getState(), modelId);
            
            return dispatch(changeGroupOpen(identifier, filterGroupName, open));
        },

        // filter actions
        changeFilterOpen: (filterGroupName, filterName, open) => (dispatch, getState) => {
            let identifier = getTableSettingsIdentifier(getState(), modelId);
            
            return dispatch(changeFilterOpen(identifier, filterGroupName, filterName, open));
        },

        // filter actions
        changeFilterOrder: (filterOrder) => (dispatch, getState) => {
            let identifier = getTableSettingsIdentifier(getState(), modelId);
            
            return dispatch(changeFilterOrder(identifier, filterOrder));
        },

        resetFilters: () => (dispatch, getState) => {
            let identifier = getTableSettingsIdentifier(getState(), modelId);
            return dispatch(resetFilters(identifier));
        },

        // field shit
        changeFieldGroupOpen: (fieldGroupName, open) => dispatch({
            type: MODEL_ACTIONS.CHANGE_FIELD_GROUP_OPEN,
            open,
            fieldGroupName,
            modelId
        }),
    };
}